import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=051d30f4&"
import script from "./mask.vue?vue&type=script&lang=js&"
export * from "./mask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports